export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-100px.jpg.39d1412b.webp";